import React from 'react';
import bindAll from 'lodash.bindall';
import event, { EVENTS } from '../../lib/event.js';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styles from './style.css';
import { setChatSteps } from '../../reducers/teach';
import ChatBody from './chat-body';
import ChatFooter from './chat-footer';
import Button from '../../../components/button/button.jsx';
import RemoveModal from '../modal/remove-modal.jsx';
import ModalManager from '../modal/modal-manager.jsx';
import backIcon from './icon_exit.png';

class ChatFrame extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
        ]);
    }


    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    handleBack(){
        // event.emit(EVENTS.NAV_BACK);
        ModalManager.open(RemoveModal, {
            onClose: () => { },
            onSubmit: () => {
                event.emit(EVENTS.NAV_BACK);
                localStorage.setItem('refresh','true');
            },
            title: '退出课程',
            content:"确定要退出当前课程吗？"
        })
    }

    componentWillUnmount() {
        window.store.dispatch(setChatSteps([]));
    }

    render() {
        const { chatSteps, chatButtons, terminal,lesson,stepMode } = this.props;

        const isGuide = lesson.record && lesson.tasks[lesson.record.current_task]
        let taskTitle = null

        lesson.tasks&&lesson.tasks.map(item=>{
            if(item.id === isGuide.id){
                taskTitle = item.name
            }

        })

        return (
            <div className={styles.chatBox}>
                <div className={styles.backTitle}>
                    <Button
                        className={styles.backButton}
                        iconSrc={backIcon}
                        onClick={()=>this.handleBack()}
                    >
                        退出课程
                    </Button>
                    <div className={styles.taskName} title={taskTitle}>{taskTitle}</div>
                </div>
                <ChatBody chatList={chatSteps} mode={stepMode} />
                <ChatFooter btns={chatButtons} position='bottom' terminal={terminal} mode={stepMode} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    chatSteps: state.teach.chatSteps,
    chatButtons: state.teach.chatButtons,
    lesson: state.teach.lesson,
    stepMode:state.teach.stepMode
});

export default connect(
    mapStateToProps
)(withRouter(ChatFrame));
